import type { RequestClientAdminsBulkDeletion } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { UserBulkDeletionFormValues } from '../schema';

export const generateBulkDeletionRequest = (
  data: UserBulkDeletionFormValues
): RequestClientAdminsBulkDeletion => ({
  file: data.file,
  selected_option: data.registrationType,
  scheduled_date: data.scheduledDate
    ? formatDate({ date: data.scheduledDate, formatType: 'yyyy-MM-dd' })
    : null,
  scheduled_hour: data.scheduledTime ?? null,
});
